// plugins
import relativeTimePlugin from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import IsYesterday from 'dayjs/plugin/isYesterday';
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const thresholds = [
  { l: 's', r: 1 },
  { l: 'ss', r: 5, d: 'second' },
  { l: 'm', r: 1 },
  { l: 'mm', r: 59, d: 'minute' },
  { l: 'h', r: 1 },
  { l: 'hh', r: 23, d: 'hour' },
  { l: 'd', r: 1 },
  { l: 'dd', r: 7, d: 'day' },
];

const relativeTimeConfig = {
  thresholds,
  rounding: Math.round,
};

export const dayjsPluginsConfig = [
  {
    plugin: relativeTimePlugin,
    config: relativeTimeConfig,
  },
  {
    plugin: updateLocale,
  },
  {
    plugin: IsYesterday,
  },
  {
    plugin: utc,
  },
  {
    plugin: isSameOrAfter,
  },
  {
    plugin: timezone,
  },
  {
    plugin: customParseFormat,
  },
];
